// Device Card Component
import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import { Circle as CircleIcon } from '@mui/icons-material';
import { IotDevice } from '../types';

interface DeviceCardProps {
  device: IotDevice;
}

const DeviceCard: React.FC<DeviceCardProps> = ({ device }) => {
  const isOnline = device.status === 1;

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        {/* Device Header */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="h6" component="h3" sx={{ flex: 1 }}>
            {device.name}
          </Typography>
          <Chip
            icon={<CircleIcon sx={{ fontSize: 12 }} />}
            label={isOnline ? 'Online' : 'Offline'}
            color={isOnline ? 'success' : 'error'}
            size="small"
          />
        </Box>

        {/* Device Info */}
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              Device Key
            </Typography>
            <Typography variant="body2">{device.deviceKey}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              IP Address
            </Typography>
            <Typography variant="body2">
              {device.ip}:{device.tcpPort}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              Last Online
            </Typography>
            <Typography variant="body2">{new Date(device.lastOnlineTime).toLocaleString()}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              Connection Status
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
              <CircleIcon sx={{ fontSize: 12, color: isOnline ? 'success.main' : 'error.main' }} />
              <Typography variant="body2" color={isOnline ? 'success.main' : 'error.main'}>
                {isOnline ? 'Connected' : 'Disconnected'}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default DeviceCard;
